import React from 'react';
import Loadable from 'react-loadable';

const Cookie = Loadable({
  loader: () => new Promise((resolve) => { setTimeout(() => { resolve(import('./index.lazy')); }, 1500); }),
  loading: () => (<div />),
});

export default Cookie;
